/* eslint-disable no-undef */

import React, {PureComponent} from 'react'
import {withStyles} from '@material-ui/core/styles/index'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Card, CardActions, CardContent, CardMedia, Button, Typography} from '@material-ui/core'

const styles = theme => ({
    card: {
        boxShadow: '0 4px 8px rgba(32, 90, 64, 0.12),0 8px 32px rgba(32, 90, 64, 0.02),0 0 0 1px rgba(32, 90, 64, 0.1)',
        borderRadius: '0px!important',
        paddingBottom: 6,
        marginBottom: theme.spacing(3),
        [theme.breakpoints.up(600)]: {
            borderRadius: '16px!important',
            marginBottom: theme.spacing(2),
        },
        '&:last-child': {
            marginBottom: 0
        },
    },
    media: {
        height: 160,
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px'
    },
    iconImage: {
        marginBottom: -theme.spacing(1) * 3
    },
    content: {
        padding: `${theme.spacing(2)}px ${theme.spacing(2)}px!important`,
        textAlign: 'center',
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        [theme.breakpoints.up(680)]: {
            padding: `${theme.spacing(2)}px ${theme.spacing(3)}px!important`,
        },
    },
    title: {
        fontSize: '1rem!important',
        fontWeight: '600!important',
        marginTop: '6px!important',
        color: '#1a2e23!important',
        fontFamily: "'Plus Jakarta Sans', sans-serif!important",
        [theme.breakpoints.up(960)]: {
            fontSize: '1.1rem!important'
        }
    },
    pos: {
        marginTop: -8,
        marginBottom: 12,
        fontSize: '0.875rem!important'
    },
    actions: {
        marginTop: -12
    },
    body: {
        fontSize: '0.85rem!important',
        fontFamily: "'Plus Jakarta Sans', sans-serif!important",
        color: '#4a5d52!important',
        lineHeight: '1.6!important',
        [theme.breakpoints.up(960)]: {
            fontSize: '0.875rem!important'
        }
    },
    button: {
        margin: 'auto'
    },
    headerIconWrapper: {
        textAlign: 'center',
        position: 'relative'
    },
    headerIcon: {
        margin: `${theme.spacing(3.75)}px 0 ${theme.spacing(0.25)}px 0`,
        fontSize: '2rem',
        color: '#2d7a58',
        zIndex: 1,
        position: 'relative'
    },
    bubble: {
        position: 'absolute',
        height: 30,
        width: 30,
        background: 'rgba(0,0,0,0.03)',
        borderRadius: 30
    },
    bubble1_1: {
        left: '30%',
        top: '70%',
        height: 30,
        width: 30
    },
    bubble1_2: {
        left: '50%',
        top: '50%',
        height: 50,
        width: 50
    },
    bubble1_3: {
        left: '70%',
        top: '30%',
        height: 10,
        width: 10
    },
    bubble2_1: {
        left: '28%',
        top: '59%',
        height: 25,
        width: 25
    },
    bubble2_2: {
        left: '53%',
        top: '37%',
        height: 50,
        width: 50
    },
    bubble2_3: {
        left: '45%',
        top: '28%',
        height: 10,
        width: 10
    },
    bubble3_1: {
        left: '59%',
        top: '30%',
        height: 25,
        width: 25
    },
    bubble3_2: {
        left: '34%',
        top: '50%',
        height: 50,
        width: 50
    },
    bubble3_3: {
        left: '28%',
        top: '45%',
        height: 10,
        width: 10
    }
})

class InfoCard extends PureComponent {
    render() {
        const {classes, title, body, image, icon, isIconImage, url} = this.props

        const bubbleArrayGenerator = [
            [classes.bubble1_1, classes.bubble1_2, classes.bubble1_3],
            [classes.bubble2_1, classes.bubble2_2, classes.bubble2_3],
            [classes.bubble3_1, classes.bubble3_2, classes.bubble3_3]
        ]
        const bubbleArray = bubbleArrayGenerator[Math.floor(Math.random() * bubbleArrayGenerator.length)]

        return (
            <Card className={classes.card}>
                {image && <CardMedia className={classes.media + ' ' + (isIconImage ? classes.iconImage : null)} image={image} title={title}/>}
                {icon && (
                    <div className={classes.headerIconWrapper}>
                        <div className={classes.bubble + ' ' + bubbleArray[0]}></div>
                        <div className={classes.bubble + ' ' + bubbleArray[1]}></div>
                        <div className={classes.bubble + ' ' + bubbleArray[2]}></div>
                        <FontAwesomeIcon size={'lg'} icon={['fas', icon]} className={classes.headerIcon}/>
                    </div>
                )}
                <CardContent className={classes.content}>
                    <Typography gutterBottom variant="h5" component="h2" className={classes.title}>
                        {url ? (
                            <a href={url} target="_blank" style={{color: 'inherit', textDecoration: 'none'}}>
                                {title}
                            </a>
                        ) : (
                            title
                        )}
                    </Typography>
                    {false && (
                        <Typography className={classes.pos} color="textSecondary">
                            Erittäin suosittu palvelu
                        </Typography>
                    )}
                    <Typography component="p" className={classes.body}>
                        {body}
                    </Typography>
                </CardContent>
                {false && (
                    <CardActions className={classes.actions}>
                        <Button size="small" color="primary" className={classes.button}>
                            Mitä tämä tarkoittaa?
                        </Button>
                    </CardActions>
                )}
            </Card>
        )
    }
}

export default withStyles(styles)(InfoCard)
